{
  "page": {
    "title": "Снайп-оповещения",
    "subtitle": "Получайте личные сообщения в Discord, когда предметы, питомцы или WoW Token, которые вы отслеживаете, появляются на аукционе ниже целевой цены."
  },
  "discordRequired": {
    "title": "Требуется Discord",
    "description": "Вам нужно привязать аккаунт Discord перед настройкой снайп-оповещений. Оповещения отправляются как личные сообщения Discord.",
    "linkButton": "Перейти в настройки для привязки Discord"
  },
  "loading": "Загрузка...",
  "notifications": {
    "title": "Снайп-уведомления",
    "description": "Получайте оповещения, когда отслеживаемые предметы или питомцы найдены ниже вашей целевой цены."
  },
  "alertStyle": {
    "title": "Стиль оповещения",
    "subtitle": "Выберите, как отображаются уведомления Discord.",
    "compact": "Компактный",
    "compactDescription": "Только текстовые эмбеды, без миниатюр. Больше оповещений на сообщение.",
    "detailed": "Подробный",
    "detailedDescription": "Расширенные эмбеды с миниатюрами предметов. Один эмбед на предмет."
  },
  "cooldown": {
    "title": "Задержка оповещений",
    "subtitle": "Сколько циклов обновления аукциона (примерно по 1 часу) пропустить перед повторным оповещением об одном и том же лоте. 0 = оповещать при каждом обновлении.",
    "cycles": "цикл(ов)",
    "save": "Сохранить",
    "saving": "Сохранение..."
  },
  "realms": {
    "title": "Реалмы для мониторинга",
    "subtitle": "Выберите реалмы {{region}} для отслеживания снайп-возможностей.",
    "placeholder": "Выберите реалмы для мониторинга",
    "removeRussian": "Удалить все российские реалмы",
    "saveButton": "Сохранить реалмы",
    "savingButton": "Сохранение..."
  },
  "addEdit": {
    "addTitle": "Добавить снайп {{type}}",
    "editTitle": "Редактировать снайп {{type}}",
    "typeLabel": "Тип",
    "typeItem": "Предмет",
    "typePet": "Питомец",
    "typeToken": "Токен",
    "typeIlvl": "ilvl",
    "itemNameLabel": "Название предмета",
    "petNameLabel": "Название питомца или ID",
    "tokenLabel": "Токен",
    "searchPlaceholder": "Поиск предмета...",
    "petPlaceholder": "Введите ID питомца (напр. 3390) или ищите по названию...",
    "priceLabelMin": "1g",
    "priceLabelMax": "9 999 999g 99s",
    "targetPriceLabel": "Целевая цена",
    "pricePlaceholder": "напр. 500g или 500g 50s",
    "ilvlMinLabel": "Мин ilvl",
    "ilvlMaxLabel": "Макс ilvl",
    "optional": "(опц)",
    "sockets": "Гнёзда",
    "secondaryStats": "Вторичные характеристики",
    "secondaryStatsHint": "(опционально, выберите до 2)",
    "statCrit": "Крит.",
    "statHaste": "Скорость",
    "statVersatility": "Универсальность",
    "statMastery": "Мастерство",
    "noItemsFound": "Предметы не найдены",
    "noPetsFound": "Питомцы не найдены",
    "anyItem": "Любой предмет",
    "addButton": "Добавить {{type}}",
    "updateButton": "Обновить {{type}}",
    "addTokenButton": "Добавить оповещение о Токене",
    "updateTokenButton": "Обновить оповещение о Токене",
    "cancelEdit": "Отмена редактирования",
    "remove": "Удалить",
    "nounItem": "предмет",
    "nounPet": "питомец",
    "categoryLabel": "Категория",
    "statSpeed": "Скорость передвижения",
    "statLeech": "Самовосстановление",
    "statAvoidance": "Ускользание"
  },
  "importExport": {
    "importButton": "Импортировать JSON {{label}}",
    "importingButton": "Импорт...",
    "exportIlvlButton": "Экспортировать JSON предметов ilvl",
    "exportButton": "Экспортировать JSON {{label}}",
    "clearAllButton": "Очистить все {{label}} ({{count}})",
    "pasteHint": "Протип: Нажмите Ctrl+V (или Cmd+V на Mac) в любом месте этой страницы, чтобы вставить и импортировать JSON-файл напрямую.",
    "clearAllTitle": "Удалить все: {{label}}",
    "clearAllConfirmButton": "Удалить все"
  },
  "tabs": {
    "items": "Предметы",
    "ilvlItems": "Предметы ilvl",
    "pets": "Питомцы",
    "token": "WoW Token"
  },
  "table": {
    "filterPlaceholder": "Фильтр по названию предмета или ID...",
    "countAll": "{{count}} правил ilvl",
    "countFiltered": "{{filtered}} из {{total}} правил ilvl",
    "countItems": "{{count}} {{noun}}",
    "countItemsFiltered": "{{filtered}} из {{total}} {{noun}}",
    "colItems": "Предметы",
    "colIlvl": "ilvl",
    "colStats": "Статистика",
    "colBuyout": "Мгновенная покупка",
    "colActions": "Действия",
    "colTargetPrice": "Целевая цена",
    "editButton": "Редактировать",
    "duplicateButton": "Дублировать",
    "deleteButton": "Удалить",
    "emptyState": "{{hint}}",
    "emptyHintItems": "Найдите предмет выше или импортируйте JSON-файл, чтобы начать.",
    "emptyHintPets": "Введите ID питомца выше или импортируйте JSON-файл, чтобы начать.",
    "emptyHintToken": "Укажите целевую цену выше, чтобы получить уведомление, когда жетон WoW опустится ниже неё.",
    "emptyHintIlvl": "Задайте ограничения по уровню предмета выше или импортируйте JSON-файл, чтобы начать.",
    "nounItems": "предмет(ы)",
    "nounPets": "питомец(ы)",
    "nounToken": "оповещение о токене",
    "nounIlvl": "правило(а) ilvl",
    "loadingName": "Загрузка...",
    "colCategory": "Категория",
    "percentLoaded": "{{percent}}% загружено",
    "editPrice": "Изменить цену",
    "inlineEditHint": "Нажмите для редактирования — Enter сохраняет, Esc отменяет"
  },
  "personalConfig": {
    "title": "Личная настройка фильтров",
    "subtitle": "Настройте фильтры ниже, чтобы задать свои параметры по умолчанию. Они будут автоматически применяться при использовании инструментов аукциона.",
    "tip": "💡 Совет: настройте фильтры так, как вам нужно, затем нажмите «Сохранить как настройки по умолчанию», чтобы сделать их постоянными.",
    "livePreviewTitle": "Предварительный просмотр фильтров",
    "livePreviewSubtitle": "Это реальные фильтры из инструмента аукциона. Установите свои значения по умолчанию по мере необходимости:",
    "saveButton": "Сохранить фильтры по умолчанию",
    "resetToSavedButton": "🔄 Сбросить к моим сохранённым настройкам",
    "resetToSystemButton": "⚙️ Сбросить к системным настройкам по умолчанию",
    "needHelp": "Нужна помощь с настройкой? Присоединяйтесь к нашему Discord",
    "dashboardSection": "Фильтр возможностей панели",
    "dashboardSectionSubtitle": "Задайте диапазон цены выкупа для предметов, отображаемых в виджете «Топ возможности» панели.",
    "dashboardBuyoutMin": "Мин. выкуп (золото)",
    "dashboardBuyoutMax": "Макс. выкуп (золото)",
    "dashboardBuyoutMaxHint": "Установите 0, чтобы без максимума",
    "dashboardSaveButton": "Сохранить конфигурацию панели",
    "itemMatchingSection": "Настройки ключа предмета",
    "itemMatchingSectionSubtitle": "Управляйте тем, как варианты предметов сопоставляются между реалмами при расчёте возможностей.",
    "ignoreStatsBeforeExpansion": "Игнорировать вторичные характеристики до этого дополнения",
    "ignoreStatsBeforeExpansionHint": "Предметы из дополнений, предшествующих выбранному, будут считаться идентичными независимо от их суффикса вторичных характеристик. Полезно для старых предметов, где различия в характеристиках не влияют на ценность для перепродажи.",
    "ignoreStatsNone": "Отключено",
    "itemMatchingSaveButton": "Сохранить настройки предметов"
  },
  "inventoryAnalysis": {
    "premiumRequired": "Для использования инструмента необходима активная подписка premium!",
    "subscriptionRequired": "Для использования инструмента необходима активная подписка!",
    "pasteCSVFirst": "Пожалуйста, сначала вставьте CSV-данные вашего инвентаря.",
    "csvPasted": "CSV инвентаря вставлен.",
    "pasteHint": "Протип: Нажмите Ctrl+V (или Cmd+V на Mac) в любом месте этой страницы, чтобы вставить CSV инвентаря напрямую.",
    "noValidItems": "В CSV-данных не найдено допустимых предметов. Проверьте формат.",
    "analysisComplete": "Анализ завершён! Найдено {{opportunities}} возможностей для продажи {{items}} предметов инвентаря.",
    "analysisFailed": "Анализ инвентаря не выполнен. Пожалуйста, попробуйте снова.",
    "title": "Анализ инвентаря",
    "description": "Вставьте ниже ваш CSV-экспорт инвентаря из игры. Мы проанализируем каждый предмет по всем доступным реалмам для поиска лучших возможностей продажи.",
    "addonInstall": "Установите аддон с",
    "addonInstallHere": "здесь",
    "csvFormatTitle": "Ожидаемый формат CSV",
    "csvFormatNote": "Разделитель — точка с запятой. BonusID разделяются двоеточием (напр.",
    "csvModifiersNote": "). Модификаторы используют",
    "csvModifiersFormat": "тип=значение",
    "csvModifiersExample": "формат (напр.",
    "sellingRealmsTitle": "Реалмы продажи для инвентаря",
    "suggestedDropships": "Рекомендуемые дропшипы",
    "inventoryDataLabel": "Данные инвентаря",
    "itemsDetected": "Обнаружен {{count}} предмет",
    "itemsDetectedPlural": "Обнаружено {{count}} предметов",
    "uploadFile": "Загрузить файл",
    "analyzeButton": "Анализировать {{count}} предметов",
    "analyzeInventoryButton": "Анализировать инвентарь",
    "clearButton": "Очистить",
    "backToInput": "Вернуться к вводу инвентаря",
    "noOpportunities": "Для предметов вашего инвентаря возможностей продажи не найдено.",
    "noOpportunitiesReason": "Это может произойти, если предметы не имеют рыночных данных TSM или не являются торгуемыми.",
    "tryAgain": "Попробовать снова",
    "exportCSV": "Экспорт для FlipQueue"
  },
  "realmConfig": {
    "setupGuideLink": "Нажмите здесь для руководства по настройке инструмента",
    "selectRegion": "Выбрать текущий регион",
    "updateBuyingRealms": "Обновить реалмы покупки для {{region}} ({{selected}} из {{total}})",
    "updateSellingRealms": "Обновить реалмы продажи для {{region}} ({{selected}} из {{max}})",
    "sellingRealmLimitTooltip": "Как подписчик с подпиской {{type}} вы можете выбрать только {{max}} реалмов продажи.",
    "addAllToBuying": "Добавить все реалмы в реалмы покупки",
    "removeAllFromBuying": "Удалить все реалмы из реалмов покупки",
    "removeRussianFromBuying": "Удалить все российские реалмы из реалмов покупки",
    "addAllToSelling": "Добавить все реалмы в реалмы продажи",
    "removeAllFromSelling": "Удалить все реалмы из реалмов продажи",
    "removeRussianFromSelling": "Удалить все российские реалмы из реалмов продажи",
    "wowAccountsTitle": "Аккаунты WoW",
    "addAccount": "Добавить аккаунт",
    "accountNamePlaceholder": "Название аккаунта (напр. WoW2)",
    "accountNameRequired": "Название аккаунта обязательно",
    "addAccountFailed": "Не удалось добавить аккаунт",
    "deleteAccountDefault": "Нельзя удалить аккаунт по умолчанию",
    "deleteAccountConfirm": "Вы уверены? Этот аккаунт будет удалён из всех назначений реалмов.",
    "deleteAccountFailed": "Не удалось удалить аккаунт",
    "updateAccountFailed": "Не удалось обновить название аккаунта",
    "assignRealmsLabel": "Назначить реалмы аккаунтам (реалм может быть в нескольких аккаунтах):",
    "selectAll": "Выбрать все",
    "deselectAll": "Снять выделение со всех",
    "noRealmsSelected": "Реалмы не выбраны",
    "addMoreAccounts": "Добавьте больше аккаунтов для назначения реалмов разным аккаунтам WoW.",
    "saveButton": "Сохранить все данные",
    "missingAccountsError": "Пожалуйста, назначьте хотя бы один аккаунт каждому реалму. Отсутствуют: {{realms}}",
    "discordQuestion": "Ещё есть вопросы? Присоединяйтесь к нашему Discord",
    "navigateToFlippingTool": "Flipping Tool",
    "navigateToDropshipTool": "Dropship Tool",
    "navigateToHousingTool": "Housing Tool",
    "navigateToTSMListGenerator": "Генератор списков TSM",
    "saveButtonDirty": "Сохранить изменения •",
    "saveSettingsFailed": "Не удалось сохранить настройки",
    "unsavedTitle": "Несохранённые изменения",
    "unsavedLeaveMessage": "У вас есть несохранённые настройки игровых миров. Если вы покинете страницу, изменения будут потеряны.",
    "unsavedLeaveConfirm": "Уйти без сохранения",
    "unsavedStay": "Остаться на странице",
    "saveBeforeNavTitle": "Сохранить изменения?",
    "saveBeforeNavMessage": "В выборе игровых миров есть несохранённые изменения. Сохраните их, чтобы инструмент использовал новые настройки.",
    "saveAndContinue": "Сохранить и продолжить",
    "deleteAccountTitle": "Удалить учётную запись WoW",
    "deleteAccountMessage": "Удалить учётную запись «{{name}}»? Она будет убрана из всех назначений игровых миров.",
    "deleteAccountConfirmButton": "Удалить",
    "renameAccountAria": "Переименовать учётную запись {{name}}",
    "deleteAccountAria": "Удалить учётную запись {{name}}",
    "confirmRenameAria": "Сохранить название учётной записи",
    "cancelRenameAria": "Отменить переименование",
    "confirmAddAria": "Добавить учётную запись",
    "cancelAddAria": "Отменить добавление"
  },
  "tsmProfile": {
    "title": "Руководство по настройке профиля TSM",
    "realmPriceAnalysis": "Анализ цен реалма",
    "minimumPriceOperation": "Операция минимальной цены",
    "maximumPriceOperation": "Операция максимальной цены",
    "normalPriceOperation": "Операция нормальной цены",
    "copyButton": "Копировать",
    "copiedSuccess": "Операция цены TSM {{operation}} скопирована в буфер обмена!",
    "copyFailed": "Не удалось скопировать в буфер обмена"
  },
  "tsmListGenerator": {
    "subscriptionRequired": "Для использования инструмента необходима активная подписка!",
    "watchVideoGuide": "Смотреть видеогайд",
    "copyTSMString": "Копировать строку TSM",
    "copyTSMFailed": "Не удалось скопировать строку TSM в буфер обмена",
    "videoGuideTitle": "Видеогайд генератора списков TSM",
    "emptyTitle": "Данные аукциона не найдены",
    "emptyDescription": "Для настроенных игровых миров не найдено данных аукциона. Проверьте настройку игровых миров или повторите попытку после следующего обновления аукционного дома.",
    "emptyConfigureButton": "Настроить игровые миры",
    "emptyRetryButton": "Повторить"
  },
  "realmStats": {
    "subscriptionRequired": "Для использования инструмента необходима активная подписка!",
    "overallStatistics": "Общая статистика",
    "realmPriceAnalysis": "Анализ цен реалма",
    "watchVideoGuide": "Смотреть видеогайд",
    "noData": "Данные реалма недоступны",
    "legend": "Легенда",
    "legendCheap": "Довольно дёшево (<{{ratio}})",
    "legendNormal": "Около нормы ({{min}}-{{max}})",
    "legendExpensive": "Значительно дорого (>{{ratio}})",
    "tooltipCheap": "Это означает, что предметы в целом ближе к среднему региональному значению продаж по цене. Здесь довольно дёшево покупать, но не так выгодно продавать.",
    "tooltipNormal": "Это означает, что предметы смешанные по отношению к среднему региональному значению продаж. Может быть хорошо для покупки и продажи.",
    "tooltipExpensive": "Это означает, что предметы в целом значительно выше среднего регионального значения продаж. Здесь довольно дорого покупать, и это может быть хорошо для продажи.",
    "colRealmName": "Название реалма",
    "colPopulation": "Население",
    "colAuctions": "Аукционы",
    "colPriceRatio": "Соотношение цен",
    "colCheaper": "Дешевле",
    "colExpensive": "Дороже",
    "colPercentCheaper": "% Дешевле",
    "colPercentExpensive": "% Дороже",
    "colPercentEqual": "% Равно",
    "totalRealms": "Всего реалмов",
    "totalAuctions": "Всего аукционов",
    "avgPriceRatio": "Ср. соотношение цен",
    "cheaperThanRegion": "Дешевле региона",
    "totalAuctionsHistory": "История всего аукционов",
    "avgPriceRatioHistory": "История ср. соотношения цен",
    "percentCheaperHistory": "История % дешевле",
    "auctionsHistory": "{{realm}} - История аукционов",
    "priceRatioHistory": "{{realm}} - История соотношения цен",
    "cheaperCountHistory": "{{realm}} - История количества дешевле",
    "expensiveCountHistory": "{{realm}} - История количества дороже",
    "percentCheaperRealm": "{{realm}} - История % дешевле",
    "percentExpensiveRealm": "{{realm}} - История % дороже",
    "percentEqualRealm": "{{realm}} - История % равно",
    "videoTitle": "Видеогайд по инструменту статистики реалма"
  },
  "tsmDataTable": {
    "colItemName": "Название предмета",
    "colCategory": "Категория",
    "colExpansion": "Дополнение",
    "colSellRate": "Скорость продаж",
    "colSaleAvg": "Ср. цена продажи",
    "colRegionMarketValue": "Рыночная стоимость региона",
    "colRegionHistorical": "История региона",
    "clickToCopy": "Нажмите для копирования: {{name}}",
    "tooltipSaleAvg": "Средняя цена, по которой предмет был продан за последние 60 дней",
    "tooltipMarketValue": "Средняя цена, по которой предмет выставлялся за последние 14 дней на всех реалмах вашего региона",
    "tooltipHistorical": "Средняя цена, по которой предмет выставлялся за последние 60 дней на всех реалмах вашего региона"
  },
  "import": {
    "confirmTitle": "Подтвердите импорт",
    "confirmMessage": "Импортировать {{count}} записей в список «{{tab}}»?",
    "confirmMessageCategory": "Импортировать {{count}} записей в список «{{tab}}» (категория: {{category}})?",
    "confirmButton": "Импортировать"
  }
}
